
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M304 96h-98.9c-7.2 0-13.1 5.8-13.1 13.1V147c0 7.2 5.8 13.1 13.1 13.1H224v64H96v-64h18.9c7.2 0 13.1-5.8 13.1-13.1v-35c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v34.9c0 7.2 5.8 13.1 13.1 13.1H32v192H13.1C5.8 352 0 357.8 0 365.1V400c0 8.8 7.2 16 16 16h98.9c7.2 0 13.1-5.8 13.1-13.1V365c0-7.2-5.8-13.1-13.1-13.1H96v-64h128v64h-18.9c-7.2 0-13.1 5.8-13.1 13.1v35c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-34.9c0-7.2-5.8-13.1-13.1-13.1H288V160h18.9c7.2 0 13.1-5.8 13.1-13.1V112c0-8.8-7.2-16-16-16zm157.4 325.8c-30.4 0-55.9-8.3-75.6-24.8-15.5-12.9-25.7-30.3-30.5-51.6-1-4.5.4-9.2 3.8-12.4 2.5-2.4 5.9-3.7 9.4-3.7l44.1-1.1h.3c5.7 0 10.8 3.6 12.7 9.1 2.4 6.7 5.6 12.2 9.6 16.4 5.9 6.3 14.6 9.3 26.4 9.3 13.6 0 23.6-4.6 30.6-14 7.2-9.7 10.9-22.3 10.9-37.2 0-14.8-3.5-27.4-10.3-37.4-6.5-9.6-16.5-14.3-30.6-14.3-6.8 0-12.7.8-17.6 2.5-8.5 3.1-14.6 8.5-18.9 16.8-.8 1.6-2.4 2.5-4.2 2.5h-.2l-44.7-2.1c-3.8-.2-7.5-1.8-9.9-4.7-2.5-2.9-3.6-6.6-3.1-10.4l19.6-154.1c.8-6.7 6.6-11.7 13.3-11.7h151.4c8.8 0 16 7.2 16 16V144c0 8.8-7.2 16-16 16H436.6l-8.7 53.4 5.4-2.9c3.2-1.7 6.1-3.1 8.6-4 9.3-3.5 20.7-5.2 33.9-5.2 26.7 0 50.3 9.1 70.1 27.1 20 18.1 30.1 44.5 30.1 78.7 0 29.6-9.6 56.4-28.6 79.7-19.2 23.1-48.2 35-86 35z"}})])
          )
        }
      }
    